import { styled } from '@mui/material/styles';

export const Container = styled('div')({
  position: 'absolute',
  right: '30px',
  bottom: '30px',

  display: 'flex',
  flexDirection: 'column',
  columnGap: '8px',

  width: 'fit-content',

  fontSize: '14px',
  fontWeight: '600',

  '& p': {
    margin: '0',
  },
});

export const ColorKeyBoxes = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '6px',
  marginTop: '4px',
  fontSize: '12px',
});

export const ColorKeyBox = styled('div')({
  display: 'grid',
  placeContent: 'center',

  width: '100px',
  padding: '12px 6px',

  borderRadius: '8px',
});
